import React from 'react';
import { motion } from 'framer-motion';
import { Globe, X } from 'lucide-react';
import { useAppStore } from '../store';
import { FLAGS, LANG_NAMES, T } from '../i18n';

export default function LanguageModal({ onClose }) {
  const { lang, setLang } = useAppStore();
  const t = T[lang] || T.fr;
  
  const languages = Object.keys(FLAGS);
  
  const handleSelect = (code) => {
    setLang(code);
    onClose();
  };
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className="relative glass-light rounded-2xl p-5 w-full max-w-sm"
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-secondary flex items-center gap-2">
            <Globe size={18} /> {t.language}
          </h2>
          <button
            onClick={onClose}
            className="p-1 rounded-lg hover:bg-white/10"
          >
            <X size={20} className="text-muted-foreground" />
          </button>
        </div>
        
        <div className="flex flex-wrap gap-2">
          {languages.map((code) => (
            <button
              key={code}
              onClick={() => handleSelect(code)}
              className={`flex flex-col items-center gap-1 p-3 rounded-xl border-2 transition-all touch-feedback ${
                lang === code 
                  ? 'border-secondary bg-secondary/10' 
                  : 'border-transparent bg-white/5 hover:bg-white/10'
              }`}
              data-testid={`lang-${code}`}
            >
              <span className="text-2xl">{FLAGS[code]}</span>
              <span className={`text-xs font-bold ${lang === code ? 'text-secondary' : 'text-muted-foreground'}`}>
                {code.toUpperCase()}
              </span>
            </button>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
